import React from 'react';
import {View} from 'react-native';
import {Card, Icon, makeStyles} from '@rn-vui/themed';
import {observer} from 'mobx-react';

import Text from '../../../../components/themed/Text';
import {useStores} from '../../../../stores/use-stores';

const PickupDeliveryDetails = observer(() => {
  const styles = useStyles();
  const {shopSelectionStore, cartStore} = useStores();

  const todayString = new Date().toLocaleDateString();
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  const tomorrowString = tomorrow.toLocaleDateString();

  const day = new Date(cartStore.selectedDay as any);
  const itemLocale = day.toLocaleDateString();

  let date = !cartStore.selectedDay
    ? ''
    : day.toLocaleDateString('en-AU', {
        month: 'short',
        day: 'numeric',
      });

  switch (itemLocale) {
    case todayString:
      date = 'Today';
      break;
    case tomorrowString:
      date = 'Tomorrow';
      break;
  }

  const [from, to] = [0, 1]
    .map(index => new Date(cartStore.selectedSlot?.dropOffWindow?.[index] || new Date()))
    .map(time => time.toLocaleString('en-AU', {timeStyle: 'short'}));

  return (
    <Card noMargin variant="outlined">
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          gap: 4,
          minHeight: 21,
        }}>
        {!cartStore.isLoadingOrder && (
          <>
            <Icon
              containerStyle={{paddingBottom: 2}}
              size={12}
              name={cartStore.isDelivery ? 'truck-outline' : 'shopping-outline'}
              type="material-community"
            />
            <Text style={styles.title}>{cartStore.isDelivery ? 'Delivery' : 'Pick up'}</Text>
          </>
        )}
      </View>
      {cartStore.isDelivery ? (
        <>
          <Text style={styles.text}>{`${cartStore.deliveryAddress?.lines?.join(' ')}`}</Text>
          <Text style={styles.text}>
            {`${cartStore.deliveryAddress?.locality} ${cartStore.deliveryAddress?.administrative_area} ${cartStore.deliveryAddress?.postal_code}`}
          </Text>
        </>
      ) : (
        <Text style={styles.text}>{shopSelectionStore.selectedStore?.name || 'Your Store'}</Text>
      )}
      <Text style={styles.text}>
        {date} at {from} – {to}
      </Text>
    </Card>
  );
});

const useStyles = makeStyles(theme => {
  return {
    title: {
      color: theme.colors?.legacy?.text?.heading?.primary,
      fontSize: 16,
      fontWeight: '600',
    },
    text: {
      fontSize: 16,
      fontWeight: '600',
    },
  };
});

export default PickupDeliveryDetails;
